import { Control } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { Tips } from '@/components/common/Tips'
import { InputControl } from '@/components/form-controls'
import { inputValidations } from '@/utils'

interface DocumentNumberControlProps {
    control: Control<any>
    watchDocumentType: string
    text: string
    isDisabled: boolean
}

export const DocumentNumberControl = ({
    control,
    watchDocumentType,
    text,
    isDisabled
}: DocumentNumberControlProps): JSX.Element => {
    const { t } = useTranslation()

    // Check if document type is foreign ID or passport (CE or CD)
    if (watchDocumentType === 'FS0017') {
        return (
            <>
                <InputControl
                    name="documentNumber"
                    control={control}
                    allowedPattern={inputValidations.documentIdPattern}
                    label={t(`${text}.documentNumber`)}
                    isDisabled={isDisabled}
                    rules={{
                        required: t(`${text}.required.documentNumber`),
                        minLength: {
                            value: 5,
                            message: t(
                                `${text}.required.documentNumberLength`,
                                { maxLength: 15 }
                            )
                        },
                        maxLength: {
                            value: 15,
                            message: t(
                                `${text}.required.documentNumberLength`,
                                { maxLength: 15 }
                            )
                        }
                    }}
                />
                <Tips text={t(`${text}.tips.passportNumbersOnly`)} />
            </>
        )
    }

    const maxLengthInput = () => {
        if (watchDocumentType === 'FS0010') {
            return 11
        }
        if (watchDocumentType === 'FS0020') {
            return 10
        }

        return 15
    }

    return (
        <InputControl
            name="documentNumber"
            control={control}
            allowedPattern={inputValidations.documentPattern}
            typeInput="number"
            label={t(`${text}.documentNumber`)}
            rules={{
                required: t(`${text}.required.documentNumber`),
                minLength: {
                    value: 5,
                    message: t(`${text}.required.documentNumberLength`, {
                        maxLength: maxLengthInput()
                    })
                },
                maxLength: {
                    value: maxLengthInput(),
                    message: t(`${text}.required.documentNumberLength`, {
                        maxLength: maxLengthInput()
                    })
                }
            }}
            isDisabled={isDisabled}
        />
    )
}
